// Client-side mirror of the backend's documents/entity-registry.js entity
// types -- maps an entity type to the route to deep-link to on click.
// Extracted from two independently-drifting inline copies (TopNav.jsx's
// bell dropdown and NotificationsPage.jsx's feed, both Phase 16) once
// Phase 17's search dropdown/results page became a genuine third consumer.
//
// `part` has no dedicated detail route (Modal-based CRUD, see Inventory's
// Parts tab), so it links to the list only. `document` deliberately has no
// entry -- a document has no detail page of its own, it always surfaces on
// its owning record's Documents tab, so a document search/notification
// result routes via its PARENT's entityType/entityId instead, one level
// removed through this same map.
export const ENTITY_LINK_PATHS = {
  customer: (id) => `/customers/${id}`,
  vehicle: (id) => `/vehicles/${id}`,
  workorder: (id) => `/work-orders/${id}`,
  reservation: (id) => `/reservations/${id}`,
  replacementvehicle: (id) => `/replacement-vehicles/${id}`,
  purchaseorder: (id) => `/inventory/purchase-orders/${id}`,
  part: () => '/inventory/parts',
  invoice: (id) => `/invoices/${id}`,
};
